import { observer } from 'mobx-react';
import React from 'react';
import Sidebar from './containers/Sidebar/Sidebar';
import PrivateRouter from './routers/PrivateRouter/PrivateRouter';
import { sidebarStore } from 'src/mobx/sidebarStore';
import socket from 'src/services/socket';
import player from '~/services/audio';
import { userStore } from '~/mobx/userStore';
import frames, { framesId } from '~/services/frames';
import Portal from '~/view/components/Portal/Portal';

@observer
class AppWrapper extends React.Component {
  componentDidMount = () => {
    /** call socket init on start private router (user logged in) */
    socket.init(userStore.user.jwt_token);

    /** initialize Beamer and Zoho ASAP */
    frames.initialize();
  };

  componentWillUnmount = () => {
    /** call socket disconnect on leave private router (user logged out) */
    socket.disconnect();

    /** stop audio notification on leave private router (user logged out) */
    player.stop();

    /** to hide UnlockBrowserAudioMessage on leave private router (user logged out) */
    player.hideUnlockBrowserAudioMessage();
  };

  public render() {
    return (
      <div className="page-container bg-graysoft">
        <Sidebar />

        <div className={`page-wrapper ${sidebarStore.isOpen ? 'page-wrapper_scale' : ''}`}>
          <div className="router-wrapper pb-4 pl-4">
            <PrivateRouter />
          </div>
        </div>

        <Portal>
          <div id={framesId} />
        </Portal>
      </div>
    );
  }
}

export default AppWrapper;
